// extracted by mini-css-extract-plugin
export default {"container":"FeaturesCards_container__9WzU7","card":"FeaturesCards_card__ViBUB","cardText":"FeaturesCards_cardText__GalhU","cardImage":"FeaturesCards_cardImage__fJ3gW"};